const i18n = {
  'en-US': {
    'menu.termsOfService': 'Terms of Service',
    'terms.title': 'Terms of Service',
    'terms.effectiveDate': 'Effective Date: March 25, 2025',
    'terms.intro':
      'Welcome to MedBox Data! Please read the following Terms of Service (hereinafter referred to as "the Terms") carefully before using this platform. By using MedBox Data, you confirm that you have read, understood, and agree to comply with these Terms. If you do not agree with any content in these Terms, please stop using this platform immediately.',

    'terms.section1.title': '1. Software License',
    'terms.section1.content1':
      '1.1 License Grant: Shoulink (Beijing) Information Technology Research Institute Co., Ltd. (hereinafter referred to as "Shoulink") grants you a personal, non-transferable, and non-exclusive license to download, install, and use the MedBox Data platform (hereinafter referred to as "the Platform") on your authorized devices.',
    'terms.section1.subtitle1': '1.2 Restrictions:',
    'terms.section1.subcontent1':
      'When using this Platform, you must comply with the following restrictions:',
    'terms.section1.list1.item1':
      'a) Do not reverse engineer, decompile, or modify the Platform;',
    'terms.section1.list1.item2':
      'b) Do not remove or alter any copyright notices or other proprietary markings included in the Platform;',
    'terms.section1.list1.item3':
      'c) Do not use the Platform for illegal purposes or engage in any unlawful activities;',
    'terms.section1.list1.item4':
      "d) Do not abuse the Platform's functions or interfere with other users' normal use;",
    'terms.section1.list1.item5':
      'e) Do not use the Platform for commercial purposes in any way.',
    'terms.section1.subtitle2': '1.3 Updates and Termination:',
    'terms.section1.subcontent2':
      'Shoulink reserves the right to update the Platform at any time, including but not limited to fixing errors, adding new features, or improving existing functions. Shoulink also reserves the right to terminate your use of the Platform if you violate these Terms.',

    'terms.section2.title': '2. Intellectual Property',
    'terms.section2.content1':
      "2.1 Shoulink's Ownership: The Platform is the property of Shoulink and is protected by the Copyright Law of the People's Republic of China and other intellectual property laws. Through these Terms, Shoulink does not grant you any intellectual property rights related to the Platform. You acknowledge and agree that your use of the Platform is limited to the scope of the license expressly granted in these Terms.",
    'terms.section2.content2':
      '2.2 User-Generated Content: When using MedBox Data, you may generate various content (hereinafter referred to as "User-Generated Content"), including but not limited to text, images, audio, etc. You retain full ownership of the User-Generated Content and agree to grant Shoulink a free, perpetual, irrevocable, worldwide license to use, copy, modify, publish, and display the User-Generated Content in order to provide the normal operation and improvement of the Platform.',

    'terms.section3.title': '3. Privacy Protection',
    'terms.section3.content':
      'Shoulink respects and protects your personal privacy. Please read our "Privacy Policy" for details on how we collect, use, and protect data.',

    'terms.section4.title': '4. Disclaimer',
    'terms.section4.content1':
      '4.1 The Platform is provided "as is," and Shoulink does not provide any express or implied warranties. You understand and agree that you use the Platform at your own risk. To the maximum extent permitted by applicable law, Shoulink will not be liable for any direct or indirect losses caused by the use of the Platform.',
    'terms.section4.list.item1': 'a) Abnormal use of the Platform;',
    'terms.section4.list.item2':
      'b) The accuracy, legality, or completeness of User-Generated Content;',
    'terms.section4.list.item3':
      'c) Damages caused by third-party intrusion or unauthorized use of the Platform;',
    'terms.section4.list.item4':
      'd) Damages caused by force majeure or other reasons beyond reasonable control.',

    'terms.section5.title': '5. Other Terms',
    'terms.section5.content1':
      "5.1 Applicable Law and Jurisdiction: These Terms are governed by the laws of the People's Republic of China and have dispute jurisdiction within the People's Republic of China.",
    'terms.section5.content2':
      '5.2 Changes to Terms: Shoulink reserves the right to modify these Terms at any time. The modified Terms will be published on the Platform and will take effect from the date of publication. If you continue to use the Platform, you are deemed to have accepted the modified Terms.',

    'terms.section6.title': '6. Platform Usage Restrictions',
    'terms.section6.content1':
      '6.1 Once MedBox Data platform services are purchased, no refunds will be provided. Under any circumstances, whether for license purchases or usage period, Shoulink does not accept refund requests.',
    'terms.section6.content2':
      '6.2 Before purchasing this Platform, please carefully evaluate and confirm your needs. Once you have purchased MedBox Data services, you agree and confirm that you are satisfied with the functionality and performance of the Platform. Therefore, once purchased, we will not be able to refund the fees you have paid.',

    'terms.section7.title': '7. Model Usage Restrictions',
    'terms.section7.content1':
      "7.1 Throughout the MedBox Data platform, all intelligent service outputs are generated by artificial intelligence models. Due to technological limitations and the special nature of generative artificial intelligence, we cannot fully guarantee the safety, reliability, availability, and continuous stability of our service models, nor the compliance, completeness, and accuracy of the generated content. The generated content does not represent Shoulink's position or views. We will continuously improve service quality but do not promise the availability and reliability of services, and are not responsible for the results of your use of our services.",
    'terms.section7.content2':
      '7.2 You are responsible for all your usage behaviors. Please ensure that the information content you input, generate, and use is legal and compliant, does not harm public social order, does not infringe upon the legitimate rights and interests of others, and does not fabricate or spread false information. Please carefully judge the generated content and do not over-rely on it. If your judgments or actions based on the generated content cause any loss or damage to you, other users, or Shoulink, you will bear all responsibility and consequences.',

    'terms.footer.company':
      'Shoulink (Beijing) Information Technology Research Institute Co., Ltd.',
    'terms.footer.date': 'Date: March 25, 2025',
  },
  'zh-CN': {
    'menu.termsOfService': '使用条款',
    'terms.title': '使用条款',
    'terms.effectiveDate': '有效日期：2025年03月25日起',
    'terms.intro':
      '欢迎使用速问！请在使用本平台之前仔细阅读以下使用条款（以下简称"本条款"）。通过使用速问，您确认已经详细阅读、理解并同意遵守本条款。如果您不同意本条款的任何内容，请立即停止使用本平台。',

    'terms.section1.title': '1. 软件许可',
    'terms.section1.content1':
      '1.1 授予许可：首联（北京）信息技术研究院有限公司（以下简称"首联"）授予您一项个人、不可转让且非独占性的许可，允许您在合法设备上下载、安装和使用速问平台（以下简称"本平台"）。',
    'terms.section1.subtitle1': '1.2 限制条件：',
    'terms.section1.subcontent1': '在使用本平台时，您必须遵守以下限制条件：',
    'terms.section1.list1.item1': 'a) 不得对本平台进行反向工程、反编译或修改；',
    'terms.section1.list1.item2':
      'b) 不得删除或更改本平台中包含的任何版权声明或其他所有权标记；',
    'terms.section1.list1.item3':
      'c) 不得将本平台用于非法目的或进行任何违法活动；',
    'terms.section1.list1.item4':
      'd) 不得滥用本平台的功能或干扰其他用户的正常使用；',
    'terms.section1.list1.item5': 'e) 不得以任何方式将本平台用于商业目的。',
    'terms.section1.subtitle2': '1.3 更新与终止：',
    'terms.section1.subcontent2':
      '首联保留随时更新本平台的权利，包括但不限于修复错误、添加新功能或改进现有功能。首联还保留在违反本条款的情况下终止您使用本平台的权利。',

    'terms.section2.title': '2. 知识产权',
    'terms.section2.content1':
      '2.1 首联的所有权：本平台是首联的财产，并受到中华人民共和国版权法和其他知识产权法律的保护。通过本条款，首联未授予您任何与本平台相关的知识产权。您承认并同意，您对本平台的使用仅限于本条款中明确授予的许可范围内。',
    'terms.section2.content2':
      '2.2 用户生成内容：在使用速问过程中，您可能会生成各种内容（以下简称"用户生成内容"），包括但不限于文字、图片、音频等。您保留对用户生成内容的全部所有权，并同意授予首联在全球范围内免费、永久、不可撤销的许可，以使用、复制、修改、发布和展示用户生成内容，以提供本平台的正常运行和改进。',

    'terms.section3.title': '3. 隐私保护',
    'terms.section3.content':
      '首联尊重并保护您的个人隐私。请详细阅读我们的《隐私政策》了解我们的数据收集、使用和保护方式。',

    'terms.section4.title': '4. 免责声明',
    'terms.section4.content1':
      '4.1 本平台按"现状"提供，首联不提供任何明示或暗示的担保。您理解并同意使用本平台的风险由您自行承担。在适用法律允许的最大范围内，首联将不对因使用本平台而导致的任何直接或间接损失承担责任。首联不对以下情况造成的损害承担责任：',
    'terms.section4.list.item1': 'a) 不正常使用本平台；',
    'terms.section4.list.item2': 'b) 用户生成内容的准确性、合法性或完整性；',
    'terms.section4.list.item3':
      'c) 第三方侵入或未经授权地使用本平台所造成的损害；',
    'terms.section4.list.item4':
      'd) 不可抗力或其他无法合理控制的原因所导致的损害。',

    'terms.section5.title': '5. 其他条款',
    'terms.section5.content1':
      '5.1 适用法律与管辖：本条款受中华人民共和国法律管辖，并在中华人民共和国境内具有争议管辖权。',
    'terms.section5.content2':
      '5.2 条款变更：首联保留随时修改本条款的权利。变更后的条款将在本平台上公布，并自公布之日起生效。如果您继续使用本平台，则视为您接受变更后的条款。',

    'terms.section6.title': '6. 平台使用限制',
    'terms.section6.content1':
      '6.1 速问平台服务一经购买，概不退款。在任何情况下，无论是购买许可证还是使用期限，首联均不接受退款申请。',
    'terms.section6.content2':
      '6.2 在购买本平台之前，请您仔细评估和确认您的需求。一旦您购买了速问服务，即表示您同意并确认您已经满意该平台的功能和性能。因此，一经购买，我们将无法退还您支付的费用。',

    'terms.section7.title': '7. 模型使用限制',
    'terms.section7.content1':
      '7.1 速问全站内，所有智能服务的输出内容由人工智能模型生成，因科技限制和生成式人工智能的特殊性，我们无法完全保证本服务模型的安全、可靠、可用和持续稳定，及生成内容的合规、完整和准确。生成内容不代表首联立场和观点。我们将不断提升服务质量，但不承诺服务的可用性和可靠性，并不对您使用本服务的结果负责。',
    'terms.section7.content2':
      '7.2 您的所有使用行为由您自行负责，请确保您输入、生成和使用的信息内容合法合规，不损害社会公共秩序，不侵犯他人合法权益，不编造或传播虚假信息等。请谨慎判断生成内容，不过度依赖。若您根据生成内容作出的判断或行为导致您、其他用户或首联遭受任何损失或损害，您将承担全部责任和后果。',

    'terms.footer.company': '首联（北京）信息技术研究院有限公司',
    'terms.footer.date': '日期：2025年03月25日',
  },
};

export default i18n;
